import { CustomErroHandlerResponse } from '@core/types';

const isCustomErroHandlerResponse = <T>(
  obj: T | CustomErroHandlerResponse,
): obj is CustomErroHandlerResponse => {
  return !!(obj as CustomErroHandlerResponse)?.statusCode;
};

export default isCustomErroHandlerResponse;
